
// Import functions from other javascript files (modules)
import { set_theme_cookie_setting, get_theme_cookie_setting } from '../../../../global/js/cookie.js';

// When document is loaded
document.addEventListener( 'DOMContentLoaded', ( event ) => {

	// Get vat-switch setting from theme settings cookie
	const vat_switch_cookie_setting = get_theme_cookie_setting( 'vat-switch' )?.primary_price_vat_setting;

    // Add event listeners and correct starting value for vat-switches
    const vat_switches = document.querySelectorAll( '.component.toggle.vat-switch input' );

	vat_switches.forEach( ( checkbox ) => {
		// Add event listeners to all vat-switches
        checkbox.addEventListener( 'change', handle_price_vat_switch_state );

		// If theme cookie setting is 'including', checkboxes need to be checked
		if ( vat_switch_cookie_setting === 'including' ) {
			checkbox.checked = true;
		} else {
			checkbox.checked = false;
		}
    });

	// Set unique id for each var-switch component.
	uniquify_vat_switch_checkbox_label_ids();

	// Flip prices to including if cookie setting had this set
	if ( vat_switch_cookie_setting === 'including' ) {
		set_price_new_and_price_vat_flipped_values( 'including' );
	} else{
		set_price_new_and_price_vat_flipped_values( 'excluding' );
	}
});


/**
 * Handle the VAT switch state and call switch_vat_prices
 */
function handle_price_vat_switch_state( clicked_vat_switch ) {
	// Get checkbox checked value
	const clicked_vat_switch_state = clicked_vat_switch.target.checked;

	// Get all vat-switch checkboxes to set them the same
	const vat_switches = document.querySelectorAll( '.component.toggle.vat-switch input' );
	vat_switches.forEach( ( checkbox ) => {
		checkbox.checked = clicked_vat_switch_state;
	});

	// Flips the prices according to the vat-switch checkboxes and update theme settings cookie
	if ( clicked_vat_switch_state ) {
		set_price_new_and_price_vat_flipped_values( 'including' );
		set_theme_cookie_setting( 'vat-switch', {'primary_price_vat_setting': 'including'} );
	} else {
		set_price_new_and_price_vat_flipped_values( 'excluding' );
		set_theme_cookie_setting( 'vat-switch', {'primary_price_vat_setting': 'excluding'} );
	}
}


/**
 * Sets prices to include or exclude VAT for price new and the flipped price.
 * To force price components to have VAT included, contain them in an element with the CSS class .force-incl-vat .
 */
function set_price_new_and_price_vat_flipped_values( new_primary_price_vat_setting ) {

	// Finding all, non VAT forced, component-price elements (excluding forced incl. VAT price components)
	let all_non_vat_forced_component_price_elements = document.querySelectorAll( '.component.price.price-1:not(.force-incl-vat .component.price.price-1 )' );

	// If there are any .comonent.price elements found
	if ( all_non_vat_forced_component_price_elements ) {

		// Loop through all .comonent.price elements found
		all_non_vat_forced_component_price_elements.forEach( price_parent_element => {

			if ( new_primary_price_vat_setting === 'including' ) {
				// If the vat-toggle is set to primarily show including

				change_price_component_to_include_vat( price_parent_element );

			} else if ( new_primary_price_vat_setting === 'excluding' ) {
				// If the vat-toggle is set to primarily show excluding

				change_price_component_to_exclude_vat( price_parent_element );
			}

		});
	}


	// Find all, forced including VAT, component-price elements (yes this happens every VAT toggle)
	let all_forced_incl_vat_component_price_elements = document.querySelectorAll( '.force-incl-vat .component.price.price-1' );

	// If there are any, forced including VAT, .comonent.price elements found
	if ( all_forced_incl_vat_component_price_elements ) {

		// Loop through all, forced including VAT, component prices
		all_forced_incl_vat_component_price_elements.forEach( price_parent_element => {

			change_price_component_to_include_vat( price_parent_element );
		});

	}
}


/**
 * Sets the price component sub elements to primarily display price including VAT
 */
function change_price_component_to_include_vat( price_parent_element ) {

	// Look for sub elements
	const price_new_element = price_parent_element.querySelector( '.component.new' );
	const price_old_element = price_parent_element.querySelector( '.component.old' );
	const price_vat_flipped = price_parent_element.querySelector( '.component.vat-flipped' );

	// If new price element is found
	if ( price_new_element ) {
		price_new_element.querySelector( 'span' ).innerHTML = price_new_element.getAttribute( 'data-price-incl-vat-text' );
	}

	// If old price element is found
	if ( price_old_element ) {
		price_old_element.querySelector( 'del' ).innerHTML = price_old_element.getAttribute( 'data-price-incl-vat-text' );
	}

	// If vat-flipped element is found
	if ( price_vat_flipped ) {
		price_vat_flipped.innerHTML = price_vat_flipped.getAttribute( 'data-price-excl-vat-text' );
	}

}


/**
 * Sets the price component sub elements to primarily display price excluding VAT
 */
function change_price_component_to_exclude_vat( price_parent_element ) {

	// Look for sub elements
	const price_new_element = price_parent_element.querySelector( '.component.new' );
	const price_old_element = price_parent_element.querySelector( '.component.old' );
	const price_vat_flipped = price_parent_element.querySelector( '.component.vat-flipped' );

	// If new price element is found
	if ( price_new_element ) {
		price_new_element.querySelector( 'span' ).innerHTML = price_new_element.getAttribute( 'data-price-excl-vat-text' );
	}

	// If old price element is found
	if ( price_old_element ) {
		price_old_element.querySelector( 'del' ).innerHTML = price_old_element.getAttribute( 'data-price-excl-vat-text' );
	}

	// If vat-flipped element is found
	if ( price_vat_flipped ) {
		price_vat_flipped.innerHTML = price_vat_flipped.getAttribute( 'data-price-incl-vat-text' );
	}

}


/**
 * Make the checkbox ID and label for ids unique per vat-switch component so (un)checking works
 */
function uniquify_vat_switch_checkbox_label_ids() {
	// Get all vat-switch components
	const vat_switch_components = document.querySelectorAll( '.component.toggle.vat-switch' );

	vat_switch_components.forEach( ( vat_switch_component, index ) => {
		const checkbox = vat_switch_component.querySelector( 'input[type="checkbox"]' );
		const label = vat_switch_component.querySelector( 'label' );

		// Set unique id for checkbox label set
		if ( checkbox && label ) {
			const unique_id = `vat-switch-${Math.random().toString( 36 ).substring( 2, 9 )}`;

			checkbox.id = unique_id;
			label.htmlFor = unique_id;
		}
	} );
}